import React from "react";
import { Helmet } from "react-helmet";
import Breadcrumb from "../../shared/breadcrumb/Breadcrumb";
import { useTranslation } from "react-i18next";
import WarrantyManagement from "../../components/warranty-management";

function WarrantyManagementPage({ setShow }) {
  const { t } = useTranslation();
  return (
    <>
      <Helmet>
        <title>
          Warranty Management Solutions to Protect Your Assets and Reduce Costs
          | GGAS
        </title>
        <meta name="keyword" content="GGAS" />
        <meta name="description" content="GGAS" />
      </Helmet>
      <Breadcrumb
        title={
          "Warranty Management Solutions to Protect Your Assets and Reduce Costs"
        }
        t={t}
      />
      <WarrantyManagement />
    </>
  );
}

export default WarrantyManagementPage;
